import NuevoGrupo from 'containers/Admin/CrearGrupo'

export default function CrearGrupo() {
  return (
    <NuevoGrupo />
  );
}